import React from 'react';
import { CheckCircleIcon, ChartBarIcon } from '@heroicons/react/24/outline';
import { useCalculator } from '../context/CalculatorContext';

const TestTypeSelector: React.FC = () => {
  const { formState, setFormState } = useCalculator();
  const { testType } = formState;
  
  const handleChange = (newTestType: 'conversion' | 'metric') => {
    setFormState({...formState, testType: newTestType});
  };

  return (
    <div>
      <label className="block text-sm font-medium mb-2">Test Type</label>
      <div className="grid grid-cols-2 gap-4">
        {/* Conversion Rate Card */}
        <div 
          className={`cursor-pointer rounded-lg p-4 border-2 transition-all ${
            testType === 'conversion' 
              ? 'border-blue-500 bg-blue-50 dark:bg-blue-900/20' 
              : 'border-gray-200 dark:border-gray-700 hover:border-blue-300 dark:hover:border-blue-700'
          }`}
          onClick={() => handleChange('conversion')}
        >
          <div className="flex justify-center mb-3">
            <div className="p-2 bg-blue-100 dark:bg-blue-800 rounded-full">
              <CheckCircleIcon className="h-6 w-6 text-blue-600 dark:text-blue-400" />
            </div>
          </div>
          <h3 className="font-medium text-center">Conversion Rate</h3>
          <p className="text-xs text-gray-500 dark:text-gray-400 mt-1 text-center">
            For binary events<br/>like clicks or purchases
          </p>
        </div>
        
        {/* Metric Card */}
        <div 
          className={`cursor-pointer rounded-lg p-4 border-2 transition-all ${
            testType === 'metric' 
              ? 'border-blue-500 bg-blue-50 dark:bg-blue-900/20' 
              : 'border-gray-200 dark:border-gray-700 hover:border-blue-300 dark:hover:border-blue-700'
          }`}
          onClick={() => handleChange('metric')}
        >
          <div className="flex justify-center mb-3">
            <div className="p-2 bg-blue-100 dark:bg-blue-800 rounded-full">
              <ChartBarIcon className="h-6 w-6 text-blue-600 dark:text-blue-400" />
            </div>
          </div>
          <h3 className="font-medium text-center">Metric</h3>
          <p className="text-xs text-gray-500 dark:text-gray-400 mt-1 text-center">
            For continuous metrics<br/>like revenue or time spent
          </p>
        </div>
      </div>
    </div>
  );
};

export default TestTypeSelector;
